<template>
  <div class="section desc-1">
    <div class="container" data-aos="fade">
      <div class="row">
        <div class="col-12">
          <h3 class="title text-center">
            Our <span class="font-bold">Providers</span>
          </h3>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-12 col-12">
          <div class="slider">
            <div class="slide-track">
              <div
                class="slide"
                v-for="(provider, index) in providers"
                :key="index"
                :title="getCustomProviderName(provider)"
              >
                <img
                  :src="`${publicPath}assets/img/providers/${provider}.png`"
                  class="provider-img"
                  :alt="provider"
                />
              </div>
              <div
                class="slide"
                v-for="(provider, index) in providers"
                :key="'clone-' + index"
                :title="getCustomProviderName(provider)"
              >
                <img
                  :src="`${publicPath}assets/img/providers/${provider}.png`"
                  class="provider-img"
                  :alt="provider"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH ?? "/",
      providers: [
        "the_ear_casino",
        "evolutiongaming",
        "greentube",
        "play_n_go",
        "pragmaticplay",
        "netent_logo",
        "habanero",
        "playson",
        "microgaming",
        "gameart",
        "goldenrace",
        "superspade",
        "egt",
        "ka",
        "ezugi",
        "1x2",
        "betsoft",
        "tvbet",
        "betgames",
        "wearecasino",
        "ct",
        "evoplay",
        "3cherry",
        "wazdan",
        "mrslotty",
        "fugaso",
        "redrake",
        "apollogames",
        "playpearls",
        "thunderspin",
        "nemesis",
        "amatic",
        "spinthon",
        "booming",
        "leander",
        "booongo",
        "conceptgaming",
        "gamzix",
        "realistic",
        "mga",
        "ainsworth",
        "fils",
        "pgsoft",
        "spinomenal",
        "hacksaw",
        "inspired",
        "tomhorn",
        "eyecon",
        "spadegaming",
        "all41",
        "endorphina",
        "belatra",
        "sagaming",
        "espresso",
        "platipus",
        "jftw",
        "te",
        "2by2",
        "eurasian",
        "switch",
        "gmw",
        "spearhead",
        "irondog",
        "bgaming",
        "onetouch",
        "btg",
        "netgame",
        "crazytooth",
        "probabilityjones",
        "vivo",
        "neonvalley",
        "genesis",
        "rabcat",
        "foxium",
        "skillz",
        "grs",
        "vibra",
        "awc68",
        "ortiz",
        "betsolutions",
        "gamefish",
        "pariplay",
        "justplay",
        "pulse8",
        "stormcraft",
        "plankgaming",
        "woohoo",
        "patagonia",
        "fantasma",
        "leap",
        "fortunefactorystudios",
        "lb",
        "gbstudios",
        "electricelephant",
        "tgc",
        "absolute",
        "puurl",
        "njoy",
        "slingshot",
        "unikrn",
        "oldskool",
        "bluberi",
        "neko",
        "kiron",
      ],
      customNames: {
        the_ear_casino: "The Ear Casino",
        evolutiongaming: "Evolution Gaming",
        greentube: "Green Tube",
        play_n_go: "Play'n GO",
        pragmaticplay: "Pragmatic Play",
        netent_logo: "NetEnt",
        wearecasino: "We are casino",
      },
    };
  },
  methods: {
    getCustomProviderName(provider) {
      if (this.customNames[provider]) {
        return this.customNames[provider];
      }
      return provider
        .replace(/_/g, " ")
        .replace(/\b[a-z]/g, (char) => char.toUpperCase());
    },
  },
  mounted() {},
};
</script>

<style scoped>
@media (max-width: 992px) {
  .section.desc-1 .multiple-items .col-card {
    flex: 0 0 33.3%;
  }
  .section.desc-1 .providers-grid > div .provider-img {
    transform: scale(1);
  }
}

.section {
  padding: 60px 15px 30px 15px;
}
.section .title {
  text-align: center;
  font-weight: 700;
  font-size: 25px;
  line-height: 1.44;
  color: #25354d;
  margin: 0px 0px 20px 0px;
}
.providers-grid {
  padding: 1rem 0 0;
}

.provider-img {
  transform: scale(1);
  transition: 0.4s;
  max-height: 50px;
}
.provider-img:hover {
  transform: scale(0.95);
  cursor: pointer;
}

.provider-img {
  max-height: 50px;
  filter: drop-shadow(1px 2px 1px rgb(200, 196, 196));
}
</style>

<style lang="scss" scoped>
@-webkit-keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-155px * 103));
  }
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-155px * 103));
  }
}
.slider {
  background: white;
  box-shadow: 0 10px 5px -13px rgba(0, 0, 0, 0.125);
  height: 100px;
  margin: auto;
  overflow: hidden;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.slider::before,
.slider::after {
  background: linear-gradient(to right, white 0%, rgba(255, 255, 255, 0) 100%);
  content: "";
  height: 100%;
  position: absolute;
  width: 75px;
  z-index: 2;
}
.slider::after {
  right: 0;
  top: 0;
  transform: rotateZ(180deg);
}
.slider::before {
  left: 0;
  top: 0;
}
.slider .slide-track {
  -webkit-animation: scroll 180s linear infinite;
  animation: scroll 180s linear infinite;
  display: flex;
  width: calc(155 * 103) px;
  animation-play-state: running;
}

.slider:hover .slide-track {
  animation-play-state: paused;
}
.slider .slide {
  height: 50px;
  width: 100%;
  padding: 3px 15px;
}

@media (max-width: 650px) {
  .slider {
    background: white;
    box-shadow: 0 10px 5px -13px rgba(0, 0, 0, 0.125);
    height: 100px;
    margin: auto;
    overflow: hidden;
    position: relative;
    width: calc(100% + 59px) !important;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    left: -32px !important;
  }
}
</style>
